import { useMutation } from '@apollo/client/react';

import { gql } from '@graphql/__generated__';
import type {
  InsertOrganisationImageMutationMutation,
  InsertTeamImageMutationMutation,
  InsertUserImageMutationMutation,
} from '@graphql/__generated__/graphql';

export const GET_USER_IMAGES = gql(/* GraphQL */ `
  query GetUserImages($user_id: uuid!) {
    user_images(where: { user_id: { _eq: $user_id } }) {
      id
      order_nr
      is_primary
      image {
        id
        url
      }
    }
  }
`);

export const GET_TEAM_IMAGES = gql(/* GraphQL */ `
  query GetTeamImages($team_id: uuid!) {
    team_images(
      where: { team_id: { _eq: $team_id } }
      order_by: { order_nr: asc }
    ) {
      id
      order_nr
      image {
        id
        url
      }
    }
  }
`);

export const GET_ORGANISATION_IMAGES = gql(/* GraphQL */ `
  query GetOrganisationImages($organisation_id: uuid!) {
    organisation_images(where: { organisation_id: { _eq: $organisation_id } }) {
      id
      order_nr
      image {
        id
        url
      }
    }
  }
`);

export const INSERT_IMAGE_MUTATIONS = {
  user: {
    mutation: gql(/* GraphQL */ `
      mutation insertUserImageMutation($object: user_images_insert_input!) {
        insert_user_images_one(object: $object) {
          id
          image {
            id
            url
          }
        }
      }
    `),
    useMutation: useMutation<InsertUserImageMutationMutation>,
  },
  team: {
    mutation: gql(/* GraphQL */ `
      mutation insertTeamImageMutation($object: team_images_insert_input!) {
        insert_team_images_one(object: $object) {
          id
          image {
            id
            url
          }
        }
      }
    `),
    useMutation: useMutation<InsertTeamImageMutationMutation>,
  },
  organisation: {
    mutation: gql(/* GraphQL */ `
      mutation insertOrganisationImageMutation(
        $object: organisation_images_insert_input!
      ) {
        insert_organisation_images_one(object: $object) {
          id
          image {
            id
            url
          }
        }
      }
    `),
    useMutation: useMutation<InsertOrganisationImageMutationMutation>,
  },
};

export const INSERT_IMAGE_ONE = gql(/* GraphQL */ `
  mutation insertImageOne($url: String!) {
    insert_images_one(object: { url: $url }) {
      id
      url
    }
  }
`);
